/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import CommonStyles from '../../../assets/styles/CommonStyles';
import mixins from '../../../assets/styles/mixins.scss';

/**
 * Recommendation Video Component
 *
 * @file ChannelsVideoCardStyle.js
 * @author Murhsid Ahamedh
 */

const ChannelsVideoPopupClass = {
  classes: {
    paywall: {
      modalWrapper: {
        position: 'absolute'
      },
      innerWrapper: {
        top: '40vh'
      }
    },
    durationIconStyles: {
      fill: '#000'
    },
    root: {
      height: '100%',
      maxHeight: 'var(--card-height)',
      minHeight: 'var(--card-height)',
      width: '100%',
      backgroundColor: 'rgb(254, 254, 254)',
      paddingInline: 0,
      overflow: 'hidden',
      wordWrap: 'break-word',
      overflowWrap: 'break-word',
      border: `1px solid ${mixins.color_elevation_alpha_12}`
    },
    title: {
      color: 'rgb(51, 51, 51)',
      fontFamily: 'TT Commons',
      fontWeight: 700,
      fontSize: 16,
      letterSpacing: 0.24,
      ...CommonStyles().truncateNumberOfLines(2)
    },
    cardHeadTitleStyles: {
      color: '#000000',
      fontSize: '16px',
      fontWeight: '700',
      letterSpacing: '0.24px',
      fontVariant: 'unset',
      textTransform: 'capitalize'
    },
    tutorName: {
      color: '#000000'
    },
    dotStyles: {
      color: '#60646d'
    },
    viewsStyles: {
      color: '#60646d'
    },
    channelLinkStyles: {
      width: '100%',
      display: 'flex',
      color: '#655591',
      fontSize: '14px',
      justifyContent: 'flex-start'
    },
    cardHeadWrapper: {
      backgroundColor: '#EBF5FF',
      height: '48px',
      padding: '8px 16px 8px 16px',
      alignItems: 'center'
    },
    questionTitle: {
      color: '#020917',
      fontSize: '18px',
      fontWeight: '700',
      wordWrap: 'break-word',
      overflowWrap: 'break-word',
      maxWidth: '100%'
    },
    optionContainer: {
      color: '#020917',
      overflow: 'hidden',
      wordWrap: 'break-word',
      overflowWrap: 'break-word'
    },
    optionText: {
      color: '#020917',
      fontSize: '14px',
      fontWeight: '400',
      wordWrap: 'break-word',
      overflowWrap: 'break-word',
      maxWidth: '100%'
    }
  }
};

export default ChannelsVideoPopupClass;
